import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'

const whiteList = ['/login', '/loading', '/403', '/404']

function updateRouteThemeClass (path) {
  if (typeof document === 'undefined') return
  const body = document.body
  Array.from(body.classList).forEach(className => {
    if (className.indexOf('rm-route-') === 0) body.classList.remove(className)
  })
  const routeName = (path || '/')
    .replace(/^\//, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .toLowerCase() || 'home'
  body.classList.add(`rm-route-${routeName}`)
}

// 路由守卫负责两件事：校验登录态、页面刷新时恢复动态路由。
// 登录后的权限加载和首次跳转由 loadingPage 页面统一处理。
router.beforeEach(async (to, from, next) => {
  updateRouteThemeClass(to.path)
  const token = getToken()

  // 无 token：白名单放行，其余跳登录
  if (!token) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 已登录访问 /login，跳转到加载页重新加载权限
  if (to.path === '/login') {
    next('/loading')
    return
  }

  // 白名单路由直接放行（loading 页自己处理权限逻辑）
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 动态路由已生成，直接放行
  if (store.state.permission.routesGenerated) {
    next()
    return
  }

  // 页面刷新后 Vuex 丢失，重新拉取权限并挂载动态路由
  try {
    const userInfo = await store.dispatch('user/refreshUserInfo')
    const authTree = userInfo && userInfo.rtRoleAuthList ? userInfo.rtRoleAuthList : []
    if (!authTree.length) {
      store.dispatch('user/logout')
      store.dispatch('permission/resetPermission')
      next('/login')
      return
    }
    const routes = await store.dispatch('permission/generateRoutes', authTree)
    routes.forEach(route => router.addRoute(route))
    next({ ...to, replace: true })
  } catch (error) {
    store.dispatch('user/logout')
    store.dispatch('permission/resetPermission')
    next('/login')
  }
})
